<div class="home-wrapper">
    <app-headerhome class="header-sec"></app-headerhome>

    <!-- ================================
    START HERO-WRAPPER AREA
================================= -->
<section class="hero-wrapper hero-wrapper8">
  <div class="container-fluid hero-box hero-bg-7 after-none">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="hero-content">
            <div class="section-heading">
              <h2
                class="sec__title cd-headline slide bg-white-mask d-inline-block text-black py-2 px-3 rounded font-size-30"
              >
                
                Experience Dignity 
              </h2>
            </div>
          </div>
          <!-- end hero-content -->
        </div>
        <!-- end col-lg-12 -->
      </div>
      <!-- end row -->
      <div class="row">
        <div class="col-lg-12">
          <div class="search-fields-container mt-4 shadow-sm">
            <div class="section-tab section-tab-2 pb-2">
              <ul class="nav nav-tabs" id="myTab3" role="tablist">
                <li class="nav-item">
                  <a
                    class="nav-link active"
                    id="one-way-tab"
                    data-toggle="tab"
                    href="#one-way"
                    role="tab"
                    aria-controls="one-way"
                    aria-selected="true"
                  >
                    One way
                  </a>
                </li>
                <!-- <li class="nav-item">
                  <a
                    class="nav-link"
                    id="round-trip-tab"
                    data-toggle="tab"
                    href="#round-trip"
                    role="tab"
                    aria-controls="round-trip"
                    aria-selected="false"
                  >
                    Round Trip
                  </a>
                </li> -->
              </ul>
            </div>
            <!-- end section-tab -->
            <div class="tab-content" id="myTabContent3">
              <div
                class="tab-pane show active"
                id="one-way"
                role="tabpanel"
                aria-labelledby="one-way-tab"
              >
                <div class="contact-form-action search-input-group-wrap">
                  <form autocomplete="off" novalidate [formGroup]="reactiveForm" (ngSubmit)="submitForm()" class="row align-items-center">
                    <div class="col-lg-6 pr-0">
                      <div
                        class="d-flex align-items-center search-input-group"
                      >
                        <div
                          class="input-box flex-grow-1 prepend-input-box"
                        >
                          <label class="label-text">From</label>
                          <div class="form-group">
                            <!-- <span class="la la-map-marker form-icon"></span> -->
                            <select name="pickup" id="aantal" formControlName="pickup" class="form-control prepend-input address-2"  >
                              <option value="">Select...</option>
                              <option *ngFor="let option of data" [value]="option">{{option}}</option> 
                            </select>
                            <button class="icon-switch" type="button">
                              <img
                                src="data:image/svg+xml;base64,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"
                                alt=""
                              />
                            </button>
                          </div>
                        </div>
                        <div class="input-box flex-grow-1 append-input-box">
                          <label class="label-text">To</label>
                          <div class="form-group">
                            <!-- <span class="la la-map-marker form-icon"></span> -->
                            <select name="dropoff" id="aantal" formControlName="dropoff" class="form-control prepend-input address-2"  >
                              <option value="">Select...</option>
                              <option *ngFor="let option of data" [value]="option">{{option}}</option> 
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- end col-lg-5 -->
                    <div class="col-lg-3 pr-0">
                      <div class="input-box">
                        <label class="label-text">Departure</label>
                        <div class="form-group">
                          <span class="la la-calendar form-icon"></span>
                          
                          <input required autocomplete="off" type="text"
                                        placeholder="Travel Date"
                                        class="form-control"
                                        formControlName="traveldate"
                                        [minDate]="today"
                                        #dp="bsDatepicker"
                                        bsDatepicker
                                        [bsConfig]="{ isAnimated: true,adaptivePosition: true,dateInputFormat: 'DD-MM-YYYY' }"
                                        [bsValue]="bsInlineValue">
                        </div>
                      </div>
                    </div>
                    <!-- end col-lg-3 -->
                    
                    <!-- end col-lg-2 -->
                    <div class="col-lg-2">
                      <button
                        type="submit" [disabled]="reactiveForm.invalid"
                        class="theme-btn w-100 text-center margin-top-20px"
                        >Make a booking</button>
                    </div>
                  </form>
                </div>
              </div>
              <!-- end tab-pane -->
              <div
                class="tab-pane"
                id="round-trip"
                role="tabpanel"
                aria-labelledby="round-trip-tab"
              >
                <div class="contact-form-action search-input-group-wrap">
                  <form autocomplete="off" novalidate [formGroup]="returnForm" (ngSubmit)="submitReturnForm()" class="row align-items-center">
                    <div class="col-lg-5 pr-0">
                      <div
                        class="d-flex align-items-center search-input-group"
                      >
                        <div
                          class="input-box flex-grow-1 prepend-input-box"
                        >
                          <label class="label-text">From</label>
                          <div class="form-group">
                            <span class="la la-map-marker form-icon"></span>
                            <select name="pickupReturn" id="aantal" formControlName="pickupReturn" class="form-control prepend-input address-2" [ngModel]="pickplaceholder" >
                              <option *ngFor="let option of data" [value]="option">{{option}}</option> 
                            </select>
                            <button class="icon-switch" type="button">
                              <img
                                src="data:image/svg+xml;base64,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"
                                alt=""
                              />
                            </button>
                          </div>
                        </div>
                        <div class="input-box flex-grow-1 append-input-box">
                          <label class="label-text">To</label>
                          <div class="form-group">
                            <span class="la la-map-marker form-icon"></span>
                            <select name="pickupReturn" id="aantal" formControlName="pickupReturn" class="form-control prepend-input address-2" [ngModel]="destplaceholder" >
                              <option *ngFor="let option of data" [value]="option">{{option}}</option> 
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- end col-lg-5 -->
                    <div class="col-lg-3 pr-0">
                      <div
                        class="d-flex align-items-center search-input-group"
                      >
                        <div class="input-box flex-grow-1">
                          <label class="label-text">Departure</label>
                          <div class="form-group">
                            <span class="la la-calendar form-icon"></span>
                            <input required autocomplete="off" type="text"
                            placeholder="Travel Date"
                            class="form-control"
                            formControlName="traveldateReturn"
                            [minDate]="today"
                            #dp="bsDatepicker"
                            bsDatepicker
                            [bsConfig]="{ isAnimated: true,adaptivePosition: true }"
                            [bsValue]="bsInlineValue">
                          </div>
                        </div>
                        <div class="input-box flex-grow-1">
                          <label class="label-text">Return</label>
                          <div class="form-group">
                            <span class="la la-calendar form-icon"></span>
                            <input required autocomplete="off" type="text"
                            placeholder="Travel Date"
                            class="form-control"
                            formControlName="returndate"
                            [minDate]="today"
                            #dp="bsDatepicker"
                            bsDatepicker
                            [bsConfig]="{ isAnimated: true,adaptivePosition: true }"
                            [bsValue]="bsInlineValue">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2">
                      <button
                        type="submit" [disabled]="returnForm.invalid"
                        class="theme-btn w-100 text-center margin-top-20px"
                        >Make a Booking</button>
                    </div>
                  </form>
                </div>
              </div>
              <!-- end tab-pane -->
            </div>
          </div>
          <!-- end main-search-input -->
        </div>
      </div>
      <!-- end row -->
    </div>
    <!-- end container -->
  </div>
</section>
<!-- end hero-wrapper -->
<!-- ================================
END HERO-WRAPPER AREA
================================= -->

<!-- ================================
START INFO AREA
================================= -->


<section
  class="info-area info-bg padding-top-140px padding-bottom-40px text-center bg-gray"
>
  <div class="container">
    <div  class="xmas-img-web _mt-20   _mob-h" style="">
      <img  height="146" src="assets/images/offers/newrouteweb.png">
    </div>
    <div  class="xmas-img-mobile  _mt-10  _desk-h" style="">
      <img class="img-fluid" src="assets/images/offers/newroutemobile.png">
    </div>  
  <div class="row">
      <!-- end col-lg-3 -->
      <div class="col-lg-4">
        <div class="icon-box">
          <div class="info-icon after-none before-none font-size-40">
            <a href="#" class="" data-toggle="modal" data-target="#comfortOnboard"><i class="la la-chair"></i></a>
            
          </div>
          <!-- end info-icon-->
          <div class="info-content pt-0">
            <h4 class="info__title font-size-16 font-weight-bold">
              Comfort on board
            </h4>
            <p>
              Our buses are equipped with large and comfortable seats.
            </p>
           
          </div>
          <!-- end info-content -->
        </div>
        <!-- end icon-box -->
      </div>
      <!-- end col-lg-4 -->
      <div class="col-lg-4">
        <div class="icon-box">
          <div class="info-icon after-none before-none font-size-40">
            <a href="#" class="" data-toggle="modal" data-target="#largestBusNetwork"><i class="la la-map-marker"></i></a>
          </div>
          <!-- end info-icon-->
          <div class="info-content pt-0">
            <h4 class="info__title font-size-16 font-weight-bold">
              Largest bus network in Kenya
            </h4>
            <p>
              Choose from over 35 travel destinations.
            </p>
            
          </div>
          <!-- end info-content -->
        </div>
        <!-- end icon-box -->
      </div>
      <!-- end col-lg-4 -->
      <div class="col-lg-4">
        <div class="icon-box">
          <div class="info-icon after-none before-none font-size-40">
            <a href="#" class="" data-toggle="modal" data-target="#enviromentFriendly"><i class="la la-leaf"></i></a>
          </div>
          <!-- end info-icon-->
          <div class="info-content pt-0">
            <h4 class="info__title font-size-16 font-weight-bold">
              Travel environmentally-friendly
            </h4>
            <p>
              Our efficient coaches are proven to have an excellent carbon
              footprint.
            </p>
            
          </div>
          <!-- end info-content -->
        </div>
        <!-- end icon-box -->
      </div>
      <!-- end col-lg-3 -->
    </div>
    <!-- end row -->
  </div>
  <!-- end container -->
</section>
<!-- ================================
END INFO AREA
================================= -->

<section class="destination-area padding-top-100px padding-bottom-80px">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="section-heading text-center">
          <h2 class="sec__title font-size-30">Top Destinations</h2>
        </div>
        <!-- end section-heading -->
      </div>
      <!-- end col-lg-12 -->
    </div>
    <!-- end row -->
    <div class="row padding-top-60px">
      <div   class="col-lg-4 responsive-column change-city">
        <div (click)="clickTopCity('Nairobi','Kitale')" class="card-item flight-card">
          <div class="card-img">
            <div class="d-block">
              <img src="assets/images/nairobi.webp" alt="destination-img">
              <span class="badge">Nairobi</span>
            </div>
          </div>
          <div class="card-body">
            <h3 class="card-title">
              <div>Nairobi to Kitale</div>
            </h3>
           
          </div>
        </div>
        <!-- end card-item -->
      </div>
        <div  (click)="clickTopCity('Nairobi','Sirare')" class="col-lg-4 responsive-column change-city">
        <div class="card-item flight-card">
          <div class="card-img">
            <div class="d-block">
              <img src="assets/images/sirare.webp" alt="destination-img">
              <span class="badge">Sirare</span>
            </div>
          </div>
          <div class="card-body">
            <h3 class="card-title">
              <div>Nairobi to Sirare</div>
            </h3>
            
          </div>
        </div>
        <!-- end card-item -->
      </div>
            <!-- end col-lg-4 -->
            <div (click)="clickTopCity('Madrid','Z')" class="col-lg-4 responsive-column change-city">
              <div class="card-item flight-card">
                <div class="card-img">
                  <div class="d-block">
                    <img src="assets/images/mumias.webp" alt="destination-img">
                    <span class="badge">Mumias</span>
                  </div>
                </div>
                <div class="card-body">
                  <h3 class="card-title">
                    <div>Nairobi to Mumias</div>
                  </h3>
                 
                </div>
              </div>
              <!-- end card-item -->
            </div>
      <!-- end col-lg-4 -->
      <div (click)="clickTopCity('Nairobi','Busia')"  class="col-lg-4 responsive-column change-city">
        <div class="card-item flight-card">
          <div class="card-img">
            <div class="d-block">
              <img src="assets/images/busia.webp" alt="destination-img">
              <span class="badge">Busia</span>
            </div>
          </div>
          <div class="card-body">
            <h3 class="card-title">
              <div>Nairobi to Busia</div>
            </h3>
          
          </div>
        </div>
        <!-- end card-item -->
      </div>
            <!-- end col-lg-4 -->
            <div (click)="clickTopCity('Nairobi','Malaba')"  class="col-lg-4 responsive-column change-city">
              <div class="card-item flight-card">
                <div class="card-img">
                  <div class="d-block">
                    <img src="assets/images/malaba.webp" alt="destination-img">
                    <span class="badge">Malaba</span>
                  </div>
                </div>
                <div class="card-body">
                  <h3 class="card-title">
                    <div>Nairobi to Malaba</div>
                  </h3>
                 
                </div>
              </div>
              <!-- end card-item -->
            </div>
      <!-- end col-lg-4 -->
      <div (click)="clickTopCity('Kisumu','Nairobi')"  class="col-lg-4 responsive-column change-city">
        <div class="card-item flight-card">
          <div class="card-img">
            <div class="d-block">
              <img src="assets/images/kisumu.webp" alt="destination-img">
              <span class="badge">Kisumu</span>
            </div>
          </div>
          <div class="card-body">
            <h3 class="card-title">
              <div>Kisumu to Nairobi</div>
            </h3>
           
          </div>
        </div>
        <!-- end card-item -->
      </div>
      <!-- end col-lg-4 -->
    


      <!-- end col-lg-4 -->
    </div>
    <!-- end row -->
  </div>
  <!-- end container -->
</section>
<!-- ================================
START LOW FARE AREA
================================= -->
<section class="low-fare-area padding-top-60px padding-bottom-10px">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <a href="#" class="discount-box d-block hover-y">
          <div class="discount-img">
            <img src="assets/images/kericho.webp" alt="Kerichoe" />
          </div>
          <!-- end discount-img -->
          <div class="discount-content">
            <div class="section-heading">
              <h2 class="sec__title mb-2 text-white font-size-30">
                 
                Discover all destinations
              </h2>
              <p class="sec__desc text-white">
                Choose from over 35 travel destinations.
              </p>
            </div>
            <!-- end section-heading -->
            
          </div>
          <!-- end discount-content -->
        </a>
      </div>
      <!-- end col-lg-12 -->
    </div>
    <!-- end row -->
  </div>
</section>
<!-- ================================
END LOW FARE AREA
================================= -->
<section class="clientlogo-area padding-top-80px  text-center">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="section-heading text-center">
          <h2 class="sec__title font-size-30">Awards</h2>
        </div>
        <!-- end section-heading -->
      </div>
      <!-- end col-lg-12 -->
    </div>
    <!-- end row -->
    <div class="theme-page-section theme-page-section-sm visible-lg visible-md">
      <div class="buupass-container">
        <div class="theme-page-section-header ">
          <div class="buupass-home-section">
            <div class="feature-list">

                <div class="list-item">
                  <div class="row">

                      <div class="col-md-8 col-xs-8">
                        <img src="assets/images/ministry.jpeg" height="50px" alt="brand image">
                      </div>
                 </div>
                </div>
                <div class="list-item">
                  <div class="row">
                    <div class="col-md-8 col-xs-8">
                      <img src="assets/images/KRA.png" height="70px" alt="brand image">
                    </div>
                 </div>
                </div>
                <div class="list-item">
                  <div class="row">
                    <div class="col-md-8 col-xs-8">
                      <img src="assets/images/superbrands.jpeg" height="80px" alt="brand image">
                    </div>
                 </div>
                </div>
                <div class="list-item">
                  <div class="row">
                    <div class="col-md-8 col-xs-8">
                      <img src="assets/images/kpmg.png" height="70px" alt="brand image">
                    </div>
                 </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- end row -->
  </div>
  <!-- end container -->

</section>

<section class="testimonial-area padding-bottom-80px">
  <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="section-heading text-center mb-0">
            <h2 class="sec__title testimonial-h2">Our Happy Travelers</h2>
          </div>
          <!-- end section-heading -->
        </div>
        <!-- end col-lg-12 -->
      </div>


      
      <div class="container-lg padding-top-50px">
        <div class="row">
          <div class="col-sm-12">
            <div id="myCarousel" class="carousel slide" data-ride="carousel">
              <!-- Carousel indicators -->
              <ol class="carousel-indicators">
                <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
                <li data-target="#myCarousel" data-slide-to="1"></li>
                <li data-target="#myCarousel" data-slide-to="2"></li>
              </ol>   
              <!-- Wrapper for carousel items -->
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="testimonial-wrapper">
                        <div class="testimonial">
                          I've used Easy Coach Ltd for the last 7 years, 4/6 times in each of those years... efficiency, reliability and most importantly safety has been your mantra all along, keep it up.
                        </div>
                        <div class="media">
                          <div class="media-body">
                            <div class="overview">
                              <div class="name"><b>Booker O.</b></div>
                              <div class="details">Kenya</div>
                              <div class="star-rating">
                                <ul class="list-inline">
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star-half-o"></i></li>
                                </ul>
                              </div>
                            </div>										
                          </div>
                        </div>
                      </div>								
                    </div>
                    <div class="col-sm-6">
                      <div class="testimonial-wrapper">
                        <div class="testimonial">
                          Great job 👍🏿
                        </div>
                        <div class="media">
                          <div class="media-body">
                            <div class="overview">
                              <div class="name"><b>Beatrice N.</b></div>
                              <div class="details">Kenya</div>
                              <div class="star-rating">
                                <ul class="list-inline">
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>								
                    </div>
                  </div>			
                </div>
                <div class="carousel-item">
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="testimonial-wrapper">
                        <div class="testimonial">
                          State of the Art 👌🏾👌🏾👌🏾👌🏾 Thank you Easy Coach ❤️❤️❤️
                        </div>
                        <div class="media">
                          <div class="media-body">
                            <div class="overview">
                              <div class="name"><b>Peniel S.</b></div>
                              <div class="details">Kenya</div>											
                              <div class="star-rating">
                                <ul class="list-inline">
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>								
                    </div>
                    <div class="col-sm-6">
                      <div class="testimonial-wrapper">
                        <div class="testimonial">
                          Keep up the good work!
                        </div>
                        <div class="media">
                          <div class="media-body">
                            <div class="overview">
                              <div class="name"><b>Bonface A.</b></div>
                              <div class="details">Kenya</div>
                              <div class="star-rating">
                                <ul class="list-inline">
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                </ul>
                              </div>
                            </div>										
                          </div>
                        </div>
                      </div>								
                    </div>
                  </div>			
                </div>
                <div class="carousel-item">
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="testimonial-wrapper">
                        <div class="testimonial">
                          This for sure is the one and only recommended passengers urban connections. Why am I not surprised that it keeps scooping the "Best and Safest Road Transport" year in year out. Love you Easy!
                        </div>
                        <div class="media">
                          <div class="media-body">
                            <div class="overview">
                              <div class="name"><b>Jerry O.</b></div>
                              <div class="details">Kenya</div>
                              <div class="star-rating">
                                <ul class="list-inline">
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                </ul>
                              </div>
                            </div>										
                          </div>
                        </div>
                      </div>								
                    </div>
                    <div class="col-sm-6">
                      <div class="testimonial-wrapper">
                        <div class="testimonial">
                          When I travel for my holidays to Kenya I always tak Easy Coach. Very professional, friendly, drivers are disciplined not speeding recklessly. Why fly to Kisumu while I can ride on Easy Coach comfy seats, spacious, 
                          enjoy the beautiful escapments and save money and it is exciting because you find your family waiting in their beautiful lounge. Easy Coach any day.
                        </div>
                        <div class="media">
                          <div class="media-body">
                            <div class="overview">
                              <div class="name"><b>Rose J.</b></div>
                              <div class="details">Kenya</div>
                              <div class="star-rating">
                                <ul class="list-inline">
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                </ul>
                              </div>
                            </div>										
                          </div>
                        </div>
                      </div>								
                    </div>
                  </div>			
                </div>
                <div class="carousel-item">
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="testimonial-wrapper">
                        <div class="testimonial">
                          Traveling back to Nairobi from Kisii aboard an @EasyCoachltd_ bus and wow! I have to admit that they are one of the best 
                          long distance service providers. Clean coaches with a courteous crew. No commotion at the boarding point. No music but 
                          hearing the engine rev is just satisfying
                        </div>
                        <div class="media">
                          <div class="media-body">
                            <div class="overview">
                              <div class="name"><b>Robinson N. Chiuri.</b></div>
                              <div class="details">Kenya</div>
                              <div class="star-rating">
                                <ul class="list-inline">
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                </ul>
                              </div>
                            </div>										
                          </div>
                        </div>
                      </div>								
                    </div>
                    <div class="col-sm-6">
                      <div class="testimonial-wrapper">
                        <div class="testimonial">
                          Am happy, very happy...
                        </div>
                        <div class="media">
                          <div class="media-body">
                            <div class="overview">
                              <div class="name"><b>Mca Frankline.</b></div>
                              <div class="details">Kenya</div>
                              <div class="star-rating">
                                <ul class="list-inline">
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                </ul>
                              </div>
                            </div>										
                          </div>
                        </div>
                      </div>								
                    </div>
                  </div>			
                </div>
                <div class="carousel-item">
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="testimonial-wrapper">
                        <div class="testimonial">
                          My best means of transport
                        </div>
                        <div class="media">
                          <div class="media-body">
                            <div class="overview">
                              <div class="name"><b>Erick M.</b></div>
                              <div class="details">Kenya</div>
                              <div class="star-rating">
                                <ul class="list-inline">
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                </ul>
                              </div>
                            </div>										
                          </div>
                        </div>
                      </div>								
                    </div>
                    <div class="col-sm-6">
                      <div class="testimonial-wrapper">
                        <div class="testimonial">
                          Very impressive!
                        </div>
                        <div class="media">
                          <div class="media-body">
                            <div class="overview">
                              <div class="name"><b>Juliana M.</b></div>
                              <div class="details">Kenya</div>
                              <div class="star-rating">
                                <ul class="list-inline">
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                  <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                </ul>
                              </div>
                            </div>										
                          </div>
                        </div>
                      </div>								
                    </div>
                  </div>			
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

   </div>
  </section>


      <!-- end testimonial-area -->

<section>
        <!-- end modal-shared -->
        <div class="modal-popup">
          <div
            class="modal fade"
            id="comfortOnboard"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <div>
                    <h5 class="modal-title title" id="exampleModalLongTitle">
                      Comfort on board
                    </h5>
                    
                  </div>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true" class="la la-close"></span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="contact-form-action">
                  <img src="assets/images/easycoachseats.webp" alt="kericho" />
                  </div>
                  <!-- end contact-form-action -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end modal-popup -->
                <!-- end modal-shared -->
                <div class="modal-popup">
                  <div
                    class="modal fade"
                    id="largestBusNetwork"
                    tabindex="-1"
                    role="dialog"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog modal-dialog-centered" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <div>
                            <h5 class="modal-title title" id="exampleModalLongTitle">
                              Largest bus network
                            </h5>
                            
                          </div>
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true" class="la la-close"></span>
                          </button>
                        </div>
                        <div class="modal-body">
                          <div class="contact-form-action">
                          <img src="assets/images/easycoach-map.webp" alt="kericho" />
                          </div>
                          <!-- end contact-form-action -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- end modal-popup -->

                                <!-- end modal-shared -->
                                <div class="modal-popup">
                                  <div
                                    class="modal fade"
                                    id="enviromentFriendly"
                                    tabindex="-1"
                                    role="dialog"
                                    aria-hidden="true"
                                  >
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                      <div class="modal-content">
                                        <div class="modal-header">
                                          <div>
                                            <h5 class="modal-title title" id="exampleModalLongTitle">
                                              Travel environmentally-friendly
                                            </h5>
                                            
                                          </div>
                                          <button
                                            type="button"
                                            class="close"
                                            data-dismiss="modal"
                                            aria-label="Close"
                                          >
                                            <span aria-hidden="true" class="la la-close"></span>
                                          </button>
                                        </div>
                                        <div class="modal-body">
                                          <div class="contact-form-action">
                                          <img src="assets/images/easycoach-map.webp" alt="kericho" />
                                          </div>
                                          <!-- end contact-form-action -->
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <!-- end modal-popup -->

                

        
</section>

<div class="section-block"></div>


<div class="section-block"></div>
    <app-footer></app-footer>
</div>
